<template>
    <div>
        <div ref="printPdf">
            <!-- Logo -->
            <div style="margin-bottom: 20px;">

                <div style="display: flex; justify-content: space-between;">
                     <div style="flex: 1;">
                        <p style="font-size: 18px; font-weight: bold; margin: 0; color: #333;">
                            {{ $t('mentora_agreement_form_title') }}
                        </p>
                    </div>
                    <div style="flex-shrink: 0;">
                        <img
                            src="../../../assets/img/BAU_Logo.png"
                            :alt="$t('agreement_form_title')"
                            style="height: 60px; width: auto;"
                            ref="logoImage"
                        />
                    </div>
             </div>
             </div>
            <!-- Personal Information -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">{{ $t('Your Personal Information') }}</h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Name :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.name ? registrationForm.name : ' ' }}{{ registrationForm.surname ? registrationForm.surname : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Middle Name :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.middle_name ? registrationForm.middle_name : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Date Of Birth :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.birthdate ? toLocaleDate(registrationForm.birthdate) : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

                <!-- Your Mailing US Address -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">
                {{ $t('your_mailing_us_address') }}
            </h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Address :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.contact_address ? registrationForm.contact_address : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">State :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.contact_state_name ? registrationForm.contact_state_name : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">City :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.contact_city_name ? registrationForm.contact_city_name : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Apartment :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.apartment ? registrationForm.apartment : '' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Zip Code :</td>
                            <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.contact_zip_code ? registrationForm.contact_zip_code : '' }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Your Home Address -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Your Home Address</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Country :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.address_country_name ? registrationForm.address_country_name : '' }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Address :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.address ? registrationForm.address : '' }}</td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Contact Information -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Contact Information</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Email :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.personal_email ? registrationForm.personal_email : '' }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Mobile Number :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.mobile_tel ? registrationForm.mobile_tel_country_code + '' + registrationForm.mobile_tel : null }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Other Phone :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.home_tel ? (registrationForm.home_tel_country_code??'') + '' + registrationForm.home_tel : null }}</td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Emergency Contact Information -->
             <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Emergency Contact Information</h4>
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse;">
                     <tbody>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Name :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.emergency_person_name ? registrationForm.emergency_person_name : null }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Relationship :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.emergency_person_relation ? registrationForm.emergency_person_relation : null }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Phone :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.emergency_person_phone ? (registrationForm.emergency_person_phone_country_code??'') + '' + registrationForm.emergency_person_phone : null }}</td>
                         </tr>
                         <tr style="border-bottom: 1px solid #eee;">
                             <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">Legal Status :</td>
                             <td style="padding: 8px 0; color: #333; vertical-align: top;">{{ registrationForm.legal_presence_type ? registrationForm.legal_presence_type : null }}</td>
                         </tr>
                     </tbody>
                 </table>
             </div>

             <!-- First Checkbox -->
             <div style="margin-bottom: 20px;">
                 <table style="width: 100%; border-collapse: collapse;">
                     <tbody>
                         <tr>
                             <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                 I confirm that the information given in this form is true, complete and accurate
                             </td>
                             <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                 <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                             </td>
                         </tr>
                     </tbody>
                 </table>
             </div>

            <!-- Program Information -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">Program Information :</h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr>
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Program Of Study</td>
                            <td style="padding: 12px; color: #555;">{{ registrationForm.program_name ? registrationForm.program_name : '-' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Program Start Date</td>
                            <td style="padding: 12px; color: #555;">{{ registrationForm.registration_date ? registrationForm.registration_date : '-' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Registration Type</td>
                            <td style="padding: 12px; color: #555;">{{ registrationForm.registration_type_text ? registrationForm.registration_type_text : '-' }}</td>
                        </tr>
                        <tr style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Enrollment Status</td>
                            <td style="padding: 12px; color: #555;">{{ studentData.student_status_text ? studentData.student_status_text : '-' }}</td>
                        </tr>
                        <!-- Mentora: Initial CEFR Level | Diğer: Total Credits -->
                        <tr v-if="isMentoraProgram">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Initial CEFR Level</td>
                            <td style="padding: 12px; color: #555;">A1-C1 (SELECT THE ONE BASED ON THE INITIAL PLACEMENT EXAM)</td>
                        </tr>
                        <tr v-else>
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">Total Credits Required for Graduation</td>
                            <td style="padding: 12px; color: #555;">
                                <span v-if="registrationForm.total_credit_required_for_graduation && registrationForm.credit">
                                    {{ registrationForm.total_credit_required_for_graduation }} / {{ registrationForm.credit }}
                                </span>
                                <span v-else>
                                    {{ registrationForm.total_credit_required_for_graduation ? registrationForm.total_credit_required_for_graduation : '-' }}
                                </span>
                                <br><small style="color: #666; font-style: italic;">(for students who do not transfer any credit from another institution)</small>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%;">
                    <tbody>
                        <tr>
                            <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                I confirm that the information given in this form is true, complete and accurate
                            </td>
                            <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Tuition and Fees -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">FEES AND CHARGES FOR THE CURRENT PERIOD OF ATTENDANCE</h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%;">
                    <tbody>
                        <tr v-for="(menu, j) in data" :key="j" style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">{{ menu.key }}</td>
                            <td style="padding: 12px; color: #555;" v-html="menu.value"></td>
                        </tr>
                    </tbody>
                </table>
                <!-- Sadece diğer programlar için: tuition artış metni -->
                <p v-if="!isMentoraProgram" style="margin-top: 15px; color: #666; font-size: 14px;">Tuition typically increases by no more than 3% each academic year. Mandatory semester fees increase every two years.</p>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I confirm that the information given in this form is true, complete and accurate
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Scholarship/Tuition Assistance -->
            <!-- Başlık: Mentora için DISCOUNTS, diğerleri için ASSISTANCE -->
            <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">
                <span v-if="isMentoraProgram">D. SCHOLARSHIPS/TUITION DISCOUNTS/AWARDS.</span>
                <span v-else>D. SCHOLARSHIPS/TUITION ASSISTANCE/AWARDS.</span>
            </h4>
            <div style="margin-bottom: 20px;">
                <table style="width: 100%; border-collapse: collapse;">
                    <tbody>
                        <tr v-for="(menu, j) in schoralShipData" :key="j" style="border-bottom: 1px solid #eee;">
                            <td style="padding: 12px;  font-weight: bold; color: #333; width: 40%; border-right: 1px solid #eee;">{{ menu.key }}</td>
                            <td style="padding: 12px; color: #555;" v-html="menu.value"></td>
                        </tr>
                    </tbody>
                </table>
                <div>
                    <!-- Mentora: 80% attendance, ESL terminolojisi -->
                    <p v-if="isMentoraProgram">*Students who earn a scholarship/tuition discount/award of any category should meet the following criteria to maintain the award:
                        <br>1) Continuously enroll in courses each module, and
                        <br>2) Maintain a minimum attendance rate of 80% for any Module, and
                        <br>3) Avoid any probation or disciplinary action for any reason.<br>
                        Scholarships, tuition discounts and/or awards are available for students who qualify. That is why continuing your studies at BAU in the Mentora ESL Program is essential. Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from the Mentora ESL Program and does not transfer into the BAU degree program, they will not receive a refund of the deposit, and/or may be required to repay the award or pay an Administrative Service Fee.
                    </p>
                    <!-- Diğer programlar: CGPA, processing fee -->
                    <p v-else>*Students who earn a scholarship or tuition assistance of any category should meet the following criteria to maintain the scholarship:
                        <br>1)	Continuously enroll in courses to meet graduation requirements (unless taking an approved Leave of Absence) and
                        <br>2)	Maintain a minimum Cumulative Grade Point Average (CGPA) of 2.0 at Undergraduate and 3.0 at Graduate level for any semester and
                        <br>3)	Avoid any disciplinary action for any reason.<br>
                        Scholarships and tuition assistance are available using the university's funds allocated for students who need additional financial aid. Therefore, if a student who was awarded any scholarship or tuition assistance withdraws from BAU for any reason, they are required to pay the award amount back for all course credits they have completed since the scholarship or tuition assistance was awarded to them. If the student wishes to transfer their SEVIS record to another institution prior to or during the semester, BAU will not refund any portion of their tuition or fees. <strong>Additionally, the student will be required to pay a processing fee of $ 2,000.</strong>
                    </p>
                </div>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I confirm that the information given in this form is true, complete and accurate
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Section E: Withdrawal Policy -->
            <!-- Mentora: Course Withdrawal Policy | Diğer: Semester Refund Policy -->
            <template v-if="isMentoraProgram">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">E. Course Withdrawal Policy</h4>
                <div style="margin-bottom: 15px; font-size: 14px;">
                    To maintain accurate enrollment records and academic standing, students wishing to withdraw from a non-credit ESL course must adhere to the following procedures:
                </div>
                <div style="margin-bottom: 10px;">
                    <p><strong>1. Submission of Request:</strong> Students must submit a formal Withdrawal Request Form to the Administrative or the ESL Program Coordinator. Verbal notifications to instructors or ceasing to attend class do not constitute an official withdrawal and may result in a failing grade.</p>
                    <p><strong>2. Deadlines and Academic Record:</strong>
                        <br>• <strong>Early Withdrawal:</strong> Before end of first week — course removed from record.
                        <br>• <strong>Mid-Session Withdrawal:</strong> After first week but before midpoint — "W" (Withdrawal) designation.
                        <br>• <strong>Late Withdrawal:</strong> Generally not permitted after the midpoint unless extenuating circumstances.
                    </p>
                    <p><strong>3. Financial Implications:</strong> Funds are non-refundable for Withdrawals submitted after the last day of the first week (typically Friday) by 5:00 pm EST.</p>
                </div>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section E. (tick)
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>
            <template v-else>
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">STUDENT'S RIGHT TO CANCEL (WITHDRAWAL/LEAVES OF ABSENCE) AND REFUND POLICY</h4>
                <div style="margin-bottom: 15px; color: #666; font-size: 14px;">
                    If a student elects to withdraw from a specific course or the university altogether, the following refund schedule will be used to determine any outstanding financial obligation for which the student may be responsible.
                </div>
                <div style="margin-bottom: 20px;">
                    <h5 style="font-size: 14px; font-weight: bold; margin: 15px 0 8px 0; color: #333;">Fall and Spring Semesters</h5>
                    <div style="margin-bottom: 15px;">
                        <table style="width: 100%; border-collapse: collapse;">
                            <tbody>
                                <tr v-for="(menu, j) in fallSpringData" :key="'fall-spring-' + j" style="border-bottom: 1px solid #eee;">
                                    <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">{{ menu.key }} :</td>
                                    <td style="padding: 8px 0; color: #333; vertical-align: top;" v-html="menu.value"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div style="margin-bottom: 20px;">
                    <h5 style="font-size: 14px; font-weight: bold; margin: 15px 0 8px 0; color: #333;">Summer Semester</h5>
                    <div style="margin-bottom: 15px;">
                        <table style="width: 100%; border-collapse: collapse;">
                            <tbody>
                                <tr v-for="(menu, j) in summerData" :key="'summer-' + j" style="border-bottom: 1px solid #eee;">
                                    <td style="font-weight: bold; width: 200px; padding: 8px 10px 8px 0; color: #555; vertical-align: top;">{{ menu.key }} :</td>
                                    <td style="padding: 8px 0; color: #333; vertical-align: top;" v-html="menu.value"></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div><p>Refunds exclude all mandatory and as-applicable fees and deposits, which are non-refundable.</p></div>
                <div><p>If the student wishes to transfer their SEVIS record to another institution prior to or during the semester, BAU will not refund any portion of their tuition or fees. <strong>Additionally, the student will be required to pay a processing fee of $ 2,000.</strong></p></div>
                <div><p>All refund requests must be submitted within sixty (60) days following the date that you either complete or withdraw from your program.</p></div>
                <div><p>All refunds will be issued in United States Dollars, minus bank transfer and processing fees, within 45 days of receiving an accurate and complete refund submission.</p></div>
                <div><p>For more information, you should refer to your tuition deposit letter.</p></div>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I confirm that the information given in this section is true, complete, and accurate section E.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </template>

            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">FINANCIAL GOOD STANDING</h4>
                <div>
                    <p>Financial good standing and a university record clear of holds are required for students to receive services. Upon course registration, students are required to sign a <strong>Financial Responsibility Agreement </strong>that outlines all financial procedures, obligations, rights, and responsibilities that are summarized below:</p>
                    <p>Services, including but not limited to access to courses, transcript issuance, diploma release, class registration (add, drop, withdrawal, etc.), and/or housing, will be immediately suspended for students with a financial balance due or a hold of any kind on their record. BAU reserves the right to terminate enrollment if the student's account remains delinquent.</p>
                </div>
                <div>
                    <p>
                        <strong>Late Fee : </strong>
                        <!-- Mentora: $80, module start date -->
                        <span v-if="isMentoraProgram">Failure to make any tuition payments on or before the module start date may result in an <strong>$80 late fee</strong>. The late fee will apply only to the tuition. Other fees (for example, activity fee, materials fees etc.) will be deducted before applying payment for tuition.</span>
                        <!-- Diğer: $25/credit/installment -->
                        <span v-else>Failure to make any payment on or before the due date results in a $25 late fee per credit per installment. The late fee will apply only to the tuition. Other fees (for example, activity fee, technology fee, etc.) will be deducted before applying payment for tuition.</span>
                    </p>
                    <p>
                        <strong>Return Check Fee : </strong> A $35 fee will be charged for each unpaid check returned by the bank. Moreover, BAU will recalculate the late fee until the balance is cleared.
                    </p>
                    <p>
                        <strong>Exceptional Cases : </strong>In the documented event of prolonged illness, accident, or death in the immediate family or other exceptional circumstances that make it impractical to complete the program, BAU will work toward a settlement that is reasonable and fair to both parties.
                    </p>
                </div>
                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I confirm that the information given in this form is true, complete and accurate
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- G. OTHER AGREEMENTS/UNDERSTANDINGS -->
            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">OTHER AGREEMENTS/UNDERSTANDINGS</h4>
                <div>
                    <!-- Madde 1: Academic Catalog -->
                    <p v-if="isMentoraProgram">
                        <strong>1. ACADEMIC CATALOG &amp; STUDENT HANDBOOK: </strong>The Academic Catalog and Mentora ESL Program Student Handbook contain a description of certain policies, procedures, and other information about BAU and the Mentora College ESL Program. BAU reserves the right to change any provision of the catalog at any time. Links:
                        <a href="https://bau.edu/mentora-esl/student-handbook/" target="_blank">Mentora Handbook</a> and
                        <a href="https://bau.edu/academic-catalog/" target="_blank">BAU Catalog</a>.
                    </p>
                    <p v-else>
                        <strong>1. ACADEMIC CATALOG : </strong>Academic Catalog contains a description of certain policies, procedures, and other information about BAU. BAU reserves the right to change any provision of the catalog at any time. The current catalog is available online and can be accessed at the following website address: https://bau.edu/academic-catalog/. Students are expected to read and be familiar with the information contained in the then-published catalog.
                    </p>

                    <!-- Madde 2: Compliance (tüm programlar) -->
                    <p>
                        <strong>2. COMPLIANCE WITH POLICIES, PROCEDURES, AND STANDARDS :</strong>
                        BAU's policies, procedures, and standards are published on the website, located at <a href="https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/">https://bau.edu/explore-bau/public-disclosure-policies/all-bau-policies/</a> Students are expected to know and must comply with and adhere to all applicable policies, procedures, and standards.
                    </p>

                    <!-- Maddeler 3-6: Sadece diğer programlar -->
                    <template v-if="!isMentoraProgram">
                        <p>
                            <strong>3. ACADEMIC CALENDAR :</strong> Students should familiarize themselves with BAU's calendar for holidays and vacations published on the website at <a href="https://bau.edu/academic-calendar/">https://bau.edu/academic-calendar/</a>. Classes will not be held on designated school vacations and may be canceled on public holidays.
                        </p>
                        <p>
                            <strong>4. DIPLOMA AWARD : </strong> Degrees are conferred by the relevant academic department for the Program. A student will receive a diploma only when the student has successfully completed all of the Program's degree requirements and has satisfied all financial obligations to BAU.
                        </p>
                        <p>
                            <strong>5. NOTICE CONCERNING TRANSFERABILITY OF CREDITS AND CREDENTIALS EARNED AT BAU : </strong>The transferability of credits you earn at BAU is at the complete discretion of the institution to which you may seek to transfer.
                        </p>
                        <p>
                            <strong>6. CAREER SERVICES : </strong>Placement assistance is provided. However, it is understood that BAU does not and cannot promise or guarantee either employment or level of income or wage rate to any student or graduate.
                        </p>
                    </template>

                    <!-- H. PLAGIARISM — Sadece Mentora -->
                    <template v-if="isMentoraProgram">
                        <p style="font-weight: bold; margin-top: 15px;">H. PLAGIARISM:</p>
                        <p>Mentora College holds its students to high standards of academic honesty. Examples of plagiarism or cheating include: cutting and pasting an internet source, no citations, copying another student's work, using AI programs (ChatGPT, etc.).</p>
                        <p>
                            <strong>1st Offense:</strong> Up to 2 verbal warnings; 0% on exam/quiz or chance to resubmit at max 50%.<br>
                            <strong>2nd Offense:</strong> Zero (0) and warning letter; placed on Behavior probation.<br>
                            <strong>3rd Offense:</strong> Zero (0) and expulsion/administrative withdrawal.
                        </p>
                        <!-- I. Academic Calendar — Sadece Mentora -->
                        <p style="font-weight: bold; margin-top: 15px;">I. ACADEMIC CALENDAR:</p>
                        <p>Students should familiarize themselves with the Mentora College ESL Program calendar published on the website at <a href="https://bau.edu/mentora-esl/mentora-academic-calendar/" target="_blank">https://bau.edu/mentora-esl/mentora-academic-calendar/</a>.</p>
                    </template>

                    <!-- Implied Consent, Complaints, Legal, Copy — madde numaraları koşullu -->
                    <p>
                        <strong>{{ isMentoraProgram ? 'J.' : '7.' }} IMPLIED CONSENT : </strong>You acknowledge and agree that BAU or its representatives, affiliates, successors, and related companies may photograph, video or otherwise record you and/or other students. Unless you have provided us with notice regarding your desire not to participate, you hereby irrevocably grant BAU and its assigns, licensees, successors in interest (collectively, the "Program Entities") the irrevocable and unrestricted right to use your name, image, voice and likeness. You can always visit <a href="https://bau.edu/explore-bau/public-disclosure-policies/communication-policies-and-procedures/">BAU Communication Policies</a> to learn more.
                    </p>
                    <p>
                        <strong>{{ isMentoraProgram ? 'K.' : '8.' }} COMPLAINTS : </strong>A student or any member of the public may file a complaint about this institution on issues that cannot be resolved by direct negotiation with the school in accordance with its written grievance policy with the Higher Education Licensure Commission (HELC) at 1050 First Street NE Washington, DC 20002, (202) 727-6436.
                    </p>
                    <p>
                        <strong>{{ isMentoraProgram ? 'L.' : '9.' }} LEGAL : </strong>The law, including the statutes of limitation, of the District of Columbia will govern this Agreement. Each of the parties hereto hereby irrevocably and unconditionally consents to submit to the sole and exclusive jurisdiction of the courts of the District of Columbia and of the United States of America located in Washington, D.C.
                    </p>
                    <p>
                        <strong>{{ isMentoraProgram ? 'M.' : '10.' }} COPY OF THE ENROLLMENT AGREEMENT : </strong>A copy of this Contract will be emailed to the student upon signing and will be accessible on the student's MyBAU account.
                    </p>
                </div>

                <div style="margin-bottom: 20px;">
                    <table style="width: 100%; border-collapse: collapse;">
                        <tbody>
                            <tr>
                                <td style="padding: 8px 0; color: #333; vertical-align: top; width: calc(100% - 30px);">
                                    I read and confirm that I understand the information in Section G.
                                </td>
                                <td style="padding: 8px 0; vertical-align: top; width: 30px; text-align: right;">
                                    <input type="checkbox" checked disabled style="width: 16px; height: 16px;">
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Financial Penalties, Part III -->
            <div style="margin-bottom: 20px;">
                <h4 style="font-size: 16px; font-weight: bold; margin: 20px 0 10px 0; color: #333; border-bottom: 1px solid #007bff; padding-bottom: 5px;">FINAL ACKNOWLEDGEMENT</h4>
                <div style="margin-bottom: 15px; font-size: 14px;">
                    I acknowledge and agree that the terms and conditions of this enrollment agreement are not subject to amendment or modification by oral agreement. I further acknowledge and agree that no oral statements have been made to me that are contrary to what is contained in this enrollment agreement. My signature below certifies that I have read, understand and agree to the terms and conditions contained in this enrollment agreement. This enrollment agreement is legally binding when signed by me and accepted by Bay Atlantic University.
                </div>
                <h4 class="mb-3 fs-6 fs-md-5 fw-bold">CONTRACT ACCEPTANCE</h4>
                <div class="mb-3 fs-6 fs-md-5">
                    I, the undersigned, have read and understood this agreement and agree that it supersedes all prior or contemporaneous verbal or written agreements and may not be modified without the written agreement of both the student and the School Official. I also understand that if I default on this agreement, I will be responsible for paying any collection fees or attorney fees incurred by BAU. By clicking the box below, I hereby affix my electronic signature, indicating my intent to be legally bound by the terms of this agreement. My signature below signifies that I have read, understood, and acknowledged all aspects of this agreement, and I have recognized my legal responsibilities under this contract.
                </div>
            </div>

            <div>
                <div><strong>{{studentData.name + ' '+studentData.surname}}</strong></div>
                <div><strong>Date: </strong>{{currentDate}}</div>
            </div>




        </div>
        <div style="width: 100%; margin-top: 3rem;">
            <div style="margin-bottom: 1.5rem; display: flex; justify-content: center;">
                <LoadingButton
                    :loading="loading"
                    :text="$t('submit')"
                    @click="submitData()"/>
            </div>
        </div>
    </div>
</template>

<script>
import EnrollmentAgreementForm from "@/services/EnrollmentAgreementForm";
import {mapGetters} from "vuex";
import moment from "moment/moment";
import LoadingButton from "@/components/elements/LoadingButton.vue";


export default {
  components: {LoadingButton},
    data() {
        return {
            disabled:false,
            loading:false,
            registrationForm: {},
            data:[],
            schoralShipData:[],
            fallSpringData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st and 2nd Week of the Semester", value: "50%" },
                { key: "3rd and 4th Weeks of the Semester", value: "25%" },
                { key: "After 4th week", value: "No refund" }
            ],
            summerData: [
                { key: "Before the semester starts", value: "100%" },
                { key: "1st Week of the Semester", value: "50%" },
                { key: "2nd Week of the Semester", value: "25%" },
                { key: "After 3rd week", value: "No refund" }
            ]
        }
    },
    computed: {
        ...mapGetters({
            studentData: "enrollmentAgreementForm/formData"
        }),
        isMentoraProgram() {
            return this.studentData?.program_code === '0702002'
        },
        currentDate(){
            return moment().format("MMMM Do YYYY")
        }
    },
    created() {
        this.getData()
    },
    methods: {
        async submitData() {
            this.loading = true;
            try {
                await this.sendToBackend();
            } catch (error) {
                console.error('Error in submitData:', error);
            } finally {
                this.loading = false;
            }
        },
        async getData() {
            const response = await EnrollmentAgreementForm.getStudentInformation(this.studentData.id)
            l            // Mentora: sabit Tuition + ESL fees | Diğer: Tuition per Credit + BAU fees
            if (this.isMentoraProgram) {
                this.data.push(
                    {
                        key: 'Admission Confirmation Deposit',
                        value: `$${data.admission_confirmation_deposit?data.admission_confirmation_deposit:0} – Non Refundable (but credited towards tuition).`,
                    },
                    {
                        key: 'Tuition Deposit',
                        value: `$${data.tuition_deposit?data.tuition_deposit:0} – Non Refundable (but credited towards tuition).`,
                    },
                    {
                        key: 'Tuition',
                        value: `$${data.tuition_per_credit?data.tuition_per_credit:0} Non F1`,
                    },
                    {
                        key: 'MANDATORY FEES',
                        value: 'Materials: $40<br>Services Fee: $30<br>Student ID Fee: $20 (only if this is your first Module at BAU-Mentora)',
                    },
                    {
                        key: 'OTHER FEES MAY APPLY',
                        value: `For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant fee(s). <strong>Information about the above-mentioned university fees and other fees can be found on Bay Atlantic University\'s website at <a href="https://bau.edu/mentora-esl/mentora-tuition-fees/" target="_blank">https://bau.edu/mentora-esl/mentora-tuition-fees/</a>.</strong>`,
                    },
                )
                this.schoralShipData.push(
                    {
                        key: 'Type of Scholarship/Discount/Award Applied During Module',
                        value: `${data.scholarship_name??''}`,
                    },
                    {
                        key: 'Start Date of Module to Which Scholarship/Discount/Award Applied',
                        value: `$${data.total_discount_amount??0} (Write "0" if the student does not have any)`,
                    },
                    {
                        key: 'Amount That Will Be Applied This Module',
                        value: `$${data.discount_amount??0}`,
                    },
                    {
                        key: 'OTHER',
                        value: `$${data.total_discount_amount??0}`,
                    },
                    {
                        key: 'Additional Awards Given for This Module',
                        value: `$${data.additional_awards_amount??0} (Write "0" if the student does not have any)`,
                    },
                )
            } else {
                this.data.push(
                    {
                        key: 'Admission Confirmation Deposit',
                        value: `$${data.admission_confirmation_deposit?data.admission_confirmation_deposit:0} – Non Refundable (but credited towards tuition).`,
                    },
                    {
                        key: 'Tuition Deposit',
                        value: `$${data.tuition_deposit?data.tuition_deposit:0} – Non Refundable (but credited towards tuition).`,
                    },
                    {
                        key: 'Tuition per Credit ',
                        value: `$${data.tuition_per_credit?data.tuition_per_credit:0}`,
                    },
                    {
                        key: 'MANDATORY FEES',
                        value: 'Student Activities and Services Fee: $135<br>Technology Fee: $165<br>Student ID Fee: $20 (only if this is your first semester at BAU)',
                    },
                    {
                        key: 'OTHER FEES MAY APPLY',
                        value: `For example, requests by students for official university documents (e.g., requests for transcripts, enrollment verifications and academic records) may require payment of the relevant <strong>university fees</strong>. Information about the above-mentioned <strong>university fees</strong> and other fees can be found on <a href="https://bau.edu/admissions/tuition-fees/" target="_blank">Bay Atlantic University\'s website</a>.`,
                    },
                )
                this.schoralShipData.push(
                    {
                        key: 'Type of the Scholarship or Tuition Assistance Awarded During Admission',
                        value: `${data.scholarship_name??''}`,
                    },
                    {
                        key: 'Amount of the Scholarship or Tuition Assistance Awarded for the Duration of the Program of Study*',
                        value: `$${data.total_discount_amount??0}`,
                    },
                    {
                        key: 'Per Credit Amount That Will be Applied This Semester',
                        value: `$${data.discount_amount??0}`,
                    },
                    {
                        key: 'OTHER',
                        value: 'Repeat credits and additional credits are exempt of the use of such scholarship/tuition assistance credits.',
                    },
                    {
                        key: 'Additional Awards Given for This Semester',
                        value: `$${data.additional_awards_amount??0}`,
                    },
                )
            }
            this.registrationForm = {
                ...this.studentData,
                registration_date: data.registration_date,
                program_name: data.program_name,
                registration_semester_academic_year: data.registration_semester_academic_year,
                anticipated_end_date: data.anticipated_end_date,
                registration_type_text: data.registration_type_text,
                total_credit_required_for_graduation: data.total_credit_required_for_graduation,
                tuition_per_credit: data.tuition_per_credit,
                total_discount_per_credit: data.discount_per_credit*data.total_credit_required_for_graduation
            }
        },
        async sendToBackend() {
            const config = {
                // html: base64String,
                contact_address:this.studentData.contact_address,
                contact_state_id:this.studentData.contact_state_id,
                contact_city_id:this.studentData.contact_city_id,
                contact_zip_code:this.studentData.contact_zip_code,
                apartment:this.studentData.apartment,
                address_country_id:this.studentData.address_country_id,
                address:this.studentData.address,
                verification_code:this.studentData.verification_code,
                personal_email:this.studentData.personal_email,
                mobile_tel:this.studentData.mobile_tel,
                mobile_tel_country_code:this.studentData.mobile_tel_country_code,
                home_tel:this.studentData.home_tel,
                home_tel_country_code:this.studentData.home_tel_country_code,
                emergency_person_phone_country_code:this.studentData.emergency_person_phone_country_code,
                emergency_person_relation:this.studentData.emergency_person_relation,
                emergency_person_name:this.studentData.emergency_person_name,
                emergency_person_phone:this.studentData.emergency_person_phone,
                birthdate:this.studentData.birthdate,
            }
          try {
            const response = await EnrollmentAgreementForm.sendForm(config);
            if (response.data.success===true) {
              this.$toast.success(this.$t('form_submission_successful'))
              this.$emit('sendSuccessForm', true)
              this.clearForm()
              this.$router.push('/dashboard');
            } else {
                    this.$toast.success(this.$t('api.' + response.data.message));
                    this.clearForm()
            }
          } catch (error) {
              if (error.data.message==="SMS_CODE_ERROR"){
                  this.$toast.error(this.$t('api.' + error.data.message));
                  this.$emit('errorSmsCode',true)

              }else{
                  this.$toast.error(this.$t('api.' + error.data.message));
              }
          }
        },
        async clearForm() {
            await this.$store.dispatch('enrollmentAgreementForm/deleteFormData');
        },

    },


};
</script>

<style scoped>
.info-row {
    display: flex;
    margin-bottom: 8px;
    align-items: flex-start;
}

.info-label {
    font-weight: bold;
    width: 150px;
    margin-right: 10px;
    color: #555;
}

.fee-row {
    border-bottom: 1px solid #eee;
}

.fee-label {
    font-weight: bold;
    width: 200px;
    padding: 8px 10px 8px 0;
    color: #555;
    vertical-align: top;
}

.fee-value {
    padding: 8px 0;
    color: #333;
    vertical-align: top;
}

@media print {
    .fee-row {
        page-break-inside: avoid;
        border-bottom: 1px solid #000;
    }

    .fee-label {
        font-weight: bold;
        color: #000;
    }

    .fee-value {
        color: #000;
    }
}
</style>

